document.addEventListener('DOMContentLoaded', () => {
	const track = document.querySelector('.slider-track');
	if (!track) return;
	const cards = [...track.children];

	cards.forEach((card) => {
		track.appendChild(card.cloneNode(true));
	});
});
